import React from 'react';
import MFAPage from 'components/SignIn/MFA/MFAPage';

const Mfa = (): JSX.Element => <MFAPage />;

export default Mfa;
